import { CartLinesUpdateEvent } from '@shopify/events';

/* Delegate form handling: forms are replaced by Shopify's cart hydration. */
document.addEventListener('submit', async (event) => {
  const form = event.target instanceof Element ? event.target.closest('form[data-fdm-cart-add]') : null;
  if (!(form instanceof HTMLFormElement)) return;
  event.preventDefault();
  if (form.dataset.fdmPending === 'true') return;

  const variantInput = form.querySelector('[name="id"]');
  const button = form.querySelector('button[type="submit"]');
  const errorLabel = form.querySelector('.fdm-upsell-item__error');
  if (!(variantInput instanceof HTMLInputElement || variantInput instanceof HTMLSelectElement) || !(button instanceof HTMLButtonElement)) return;
  const variantId = Number(variantInput.value);
  if (!Number.isSafeInteger(variantId) || variantId < 1) {
    if (errorLabel) {
      errorLabel.textContent = 'Choisissez une option disponible.';
      errorLabel.hidden = false;
    }
    return;
  }

  form.dataset.fdmPending = 'true';
  button.disabled = true;
  if (errorLabel) errorLabel.hidden = true;

  const deferredEventPromise = CartLinesUpdateEvent.createPromise();
  document.dispatchEvent(new CartLinesUpdateEvent({
    action: 'add',
    context: 'product',
    lines: [{ merchandiseId: String(variantId), quantity: 1 }],
    promise: deferredEventPromise.promise,
  }));

  try {
    const sectionIds = [...new Set(
      Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
        .map((component) => component.getAttribute('data-section-id'))
        .filter(Boolean)
    )];
    const response = await fetch(Theme.routes.cart_add_url, {
      method: 'POST',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify({
        items: [{id: variantId, quantity: 1}],
        sections: sectionIds.join(','),
        sections_url: window.location.pathname,
      }),
    });
    const payload = await response.json();
    if (!response.ok || payload.status) throw new Error(payload.description || payload.message || 'Impossible d’ajouter cet article.');

    const cartResponse = await fetch(Theme.routes.cart_url + '.js', {headers: {'Accept': 'application/json'}});
    if (!cartResponse.ok) throw new Error('Le panier n’a pas pu être actualisé.');
    const cart = await cartResponse.json();

    deferredEventPromise.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: {
        didError: false,
        source: 'fdm-cart-upsell',
        sourceId: 'fdm-cart-upsell',
        itemCount: 1,
        items: cart.items,
        sections: payload.sections || {},
      },
    });
  } catch (error) {
    deferredEventPromise.reject(error);
    if (errorLabel) {
      errorLabel.textContent = error instanceof Error ? error.message : 'Une erreur est survenue.';
      errorLabel.hidden = false;
    }
  } finally {
    form.dataset.fdmPending = 'false';
    button.disabled = false;
  }
});

/* Carousel arrow controls are delegated because the cart is re-rendered after updates. */
document.addEventListener('click', (event) => {
  const arrow = event.target instanceof Element ? event.target.closest('[data-fdm-carousel-step]') : null;
  if (!(arrow instanceof HTMLButtonElement)) return;
  const carousel = arrow.closest('[data-fdm-carousel]');
  const track = carousel?.querySelector('[data-fdm-carousel-track]');
  const card = track?.querySelector('.fdm-upsell-item');
  if (!(track instanceof HTMLElement) || !(card instanceof HTMLElement)) return;
  const step = Number(arrow.dataset.fdmCarouselStep);
  if (step !== 1 && step !== -1) return;
  const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
  track.scrollBy({
    left: step * (card.getBoundingClientRect().width + gap),
    behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
  });
});

/* Update the displayed price when the customer chooses a different variant. */
document.addEventListener('change', (event) => {
  const target = event.target;
  if (!(target instanceof HTMLSelectElement) || !target.matches('.fdm-upsell-item__variant')) return;
  const card = target.closest('.fdm-upsell-item');
  const label = card?.querySelector('[data-fdm-selected-price]');
  const price = target.selectedOptions[0]?.dataset.price;
  if (label && price) label.textContent = price;

  const photo = card?.querySelector('[data-fdm-variant-image]');
  const emptyPhoto = card?.querySelector('[data-fdm-missing-image]');
  const selected = target.selectedOptions[0];
  const imageUrl = selected?.dataset.image || '';
  if (photo instanceof HTMLImageElement) {
    if (imageUrl) {
      photo.src = imageUrl;
      photo.alt = selected?.dataset.alt || '';
      photo.hidden = false;
    } else {
      photo.removeAttribute('src');
      photo.hidden = true;
    }
  }
  if (emptyPhoto instanceof HTMLElement) emptyPhoto.hidden = Boolean(imageUrl);
});
